import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState, ReactNode } from 'react';
interface LinkModalContextType {
  isOpen: boolean;
  initialUrl: string;
  initialLabel: string;
  title: string;
  onSubmit: (url: string, label?: string) => void;
  onRemove?: () => void;
  openLinkModal: (initialUrl: string, initialLabel: string, title: string, onSubmit: (url: string, label?: string) => void, onRemove?: () => void) => void;
  closeLinkModal: () => void;
}
const LinkModalContext = createContext<LinkModalContextType | undefined>(undefined);
export const useLinkModal = () => {
  const context = useContext(LinkModalContext);
  if (context === undefined) {
    throw new Error("useLinkModal must be used within a LinkModalProvider");
  }
  return context;
};
interface LinkModalProviderProps {
  children: ReactNode;
}
export const LinkModalProvider: React.FC<LinkModalProviderProps> = t0 => {
  const $ = _c(14);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [initialUrl, setInitialUrl] = useState("");
  const [initialLabel, setInitialLabel] = useState("");
  const [title, setTitle] = useState("");
  const [onSubmitCallback, setOnSubmitCallback] = useState(_temp2);
  const [onRemoveCallback, setOnRemoveCallback] = useState(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (initialUrl_0, initialLabel_0, title_0, onSubmit, onRemove) => {
      setInitialUrl(initialUrl_0);
      setInitialLabel(initialLabel_0);
      setTitle(title_0);
      setOnSubmitCallback(() => onSubmit);
      setOnRemoveCallback(() => onRemove);
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openLinkModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeLinkModal = t2;
  let t3;
  if ($[2] !== onSubmitCallback) {
    t3 = (url, label) => {
      onSubmitCallback(url, label);
      closeLinkModal();
    };
    $[2] = onSubmitCallback;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSubmit = t3;
  let t4;
  if ($[4] !== handleSubmit || $[5] !== initialLabel || $[6] !== initialUrl || $[7] !== isOpen || $[8] !== onRemoveCallback || $[9] !== title) {
    t4 = {
      isOpen,
      initialUrl,
      initialLabel,
      title,
      onSubmit: handleSubmit,
      onRemove: onRemoveCallback,
      openLinkModal,
      closeLinkModal
    };
    $[4] = handleSubmit;
    $[5] = initialLabel;
    $[6] = initialUrl;
    $[7] = isOpen;
    $[8] = onRemoveCallback;
    $[9] = title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== t4) {
    t5 = <LinkModalContext.Provider value={t4}>{children}</LinkModalContext.Provider>;
    $[11] = children;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp() {}
function _temp2() {
  return _temp;
}